import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  // Derive current language directly from i18n — no local state needed
  const currentLang: 'en' | 'de' = i18n.language === 'en' ? 'en' : 'de';

  const toggleLanguage = () => {
    const newLang = currentLang === 'de' ? 'en' : 'de';
    localStorage.setItem('i18nextLng', newLang);
    // changeLanguage re-renders all components using useTranslation automatically
    void i18n.changeLanguage(newLang);
    // Keep the e-mail language in sync for signed-in users (ignored when not signed in)
    void fetch('/api/auth/locale', {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ locale: newLang }),
    }).catch(() => undefined);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 dark:border-white/15 px-3 py-1.5 text-xs font-medium text-ink transition-all hover:bg-raised hover:text-ink"
    >
      <Languages className="h-3.5 w-3.5" />
      {currentLang === 'de' ? 'EN' : 'DE'}
    </button>
  );
}
